<template>
  <div v-if="permissions.includes('document_template.read')">
    <div class="container-fluid mt-4" style="color:#000000">
      <button class="btn btn-secondary mb-3" @click="$router.back()">
        ← Back
      </button>
      <!-- <div class="pl-4 pr-5 pt-0"> -->
        <div class="card shadow-sm">
          <div class="card-body">
            <div class="d-flex flex-wrap align-items-center mb-3">
            <div class="d-flex align-items-center">
            </div>
              <label class="form-label mb-0" style="min-width: 120px; font-weight: 500;">Name</label>
              <input 
                type="text" 
                class="form-control form-control-sm" 
                v-model="editName" 
                placeholder="Name"
                style="width: 300px;" 
              />
              <button class="btn btn-success btn-sm ms-2" @click="updateDocumentName">
                Save
              </button>
              <button class="btn btn-outline-secondary btn-sm ms-2" @click="editName = documentName">
                Cancel
              </button>
            </div>
            <hr class="my-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <label class="form-label mb-0" style="font-weight: 500;">Templates</label>
              <button class="btn btn-primary btn-sm" @click="openModal">
                Add Template
              </button>
            </div>
            <vue-good-table styleClass="vgt-table no-border" :rows="templates" :columns="columns">
            <template slot="table-row" slot-scope="props">
              <template v-if="props.column.field === 'name'">
                {{ toPascalCase(props.row.name) }}
              </template>
              <template v-if="props.column.field === 'action'">
                <button class="btn-pencil mx-2" v-if="permissions.includes('document_template.write')"
                  @click="editTemplate(props.row)">
                  <i class="fa fa-pencil fs-5"></i>
                </button>
                <button class="btn-trash" v-if="permissions.includes('document_template.delete')"
                  @click="removeTemplate(props.row.id)">
                  <i class="fa fa-trash fs-5"></i>
                </button>
              </template>
            </template>
            </vue-good-table>
          </div>
        </div>
      <!-- </div> -->

      <!-- TEMPLATE MODAL -->
      <div class="modal fade" ref="modal" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ form.id ? "Edit Template" : "Add Template" }}
              </h5>
              <button class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <label class="mb-2">Name</label>
              <input class="form-control mb-3" v-model="form.name" placeholder="Enter name" />

           <label class="mb-2">Template Type</label>
            <select v-model="form.template_type" class="form-control mb-3">
              <option value="existing_details">Existing Details</option>
              <option value="custom_details">Custom Details</option>
            </select>

              <!-- Field Selection for Custom Details -->
              <div v-if="form.template_type === 'custom_details'" class="mb-2 p-2 bg-light border rounded">
                  <div class="mt-2">
                  <label class="form-label">Add Field</label>
                  <select 
                    class="form-control form-control-sm"
                    @change="addTemplateField"
                  >
                    <option value="">-- Select Field --</option>

                    <option
                      v-for="field in availableFields"
                      :key="field.id"
                      :value="JSON.stringify(field)"
                      :disabled="isFieldSelected(field.id)"
                    >
                      {{ field.label }} ({{ field.name }})
                    </option>
                  </select>
                </div>
                <h6 v-if="form.templateFields.length > 0" class="mt-3 mb-3">Selected Fields for This Template</h6>
                <div v-if="availableFields.length === 0" class="alert alert-info">
                  No fields available. Create fields first from "Manage Fields".
                </div>
                <draggable 
                  v-else
                  v-model="form.templateFields"
                  animation="200"
                  ghost-class="bg-light"
                  chosen-class="shadow-sm"
                  class="list-group border rounded"
                  style="max-height: 250px; overflow: auto;"
                >
                  <div
                    v-for="(field, idx) in form.templateFields"
                    :key="field.id"
                    class="list-group-item d-flex align-items-center"
                    style="min-width: 600px; cursor: move;"
                  >
                    <!-- Drag Icon -->
                    <i class="fa fa-bars text-muted me-3 flex-shrink-0"></i>

                    <!-- Order -->
                    <span class="badge bg-secondary me-2 flex-shrink-0">
                      {{ idx + 1 }}
                    </span>

                    <!-- Field Text -->
                    <div class="flex-grow-1 text-break">
                        {{ field.label }}
                      <small class="text-muted">
                        ({{ field.name }})
                      </small>
                    </div>

                    <!-- Delete Button -->
                    <button
                      class="btn-trash"
                      @click="removeTemplateField(idx)"
                    >
                     <i class="fa fa-trash fs-5"></i>
                    </button>
                  </div>
                </draggable>
              </div>

              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="mb-0">Template HTML</label>
                <button class="btn btn-sm btn-secondary" @click="formatCode">
                  Format HTML
                </button>
              </div>
              <codemirror ref="cm" v-model="form.html" :options="cmOptions" class="code-editor" :key="form.id || 0" />

            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" @click="save">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  <div v-else>
    <UnauthorizedPage />
  </div>
</template>

<script>
import * as bootstrap from "bootstrap";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import UnauthorizedPage from "@/views/Layouts/UnauthorizedPage.vue";
import user from "@/ajax/user";
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/mode/xml/xml.js";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/css/css.js";
import "codemirror/mode/htmlmixed/htmlmixed.js";
import "codemirror/addon/edit/closebrackets.js";
import "codemirror/addon/edit/matchbrackets.js";
import prettier from "prettier/standalone";
import parserHtml from "prettier/parser-html";
import draggable from "vuedraggable";

export default {
  name: "DocumentEdit",
  components: { VueGoodTable, codemirror, UnauthorizedPage, draggable },

  data() {
    return {
      documentId: this.$route.params.id,
      documentName: "",
      editName: "",
      templates: [],
      modal: null,
      permissions: window.localStorage.getItem("permissions"),
      availableFields: [],
      form: {
        id: null,
        name: "",
        template_type: "existing_details",
        html: "",
        templateFields: []
      },

      columns: [
        {
          label: "Name",
          field: "name",
          thClass: "custom-th",
          tdClass: "custom-td",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          thClass: "disable-sorting custom-th",
          tdClass: "custom-td text-nowrap",
          width: "15%",
        },
      ],

      cmOptions: {
        mode: "htmlmixed",
        theme: "material",
        lineNumbers: true,
        lineWrapping: true,
        autoCloseBrackets: true,
        matchBrackets: true,
        tabSize: 2,
        indentUnit: 2,
      }
    };
  },

  methods: {
    isFieldSelected(fieldId) {
      return this.form.templateFields.some(f => f.id === fieldId);
    },
    toPascalCase(str) {
      if (!str) return '';
      return str
        .toLowerCase()
        .split(/[\s_-]+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    formatCode() {
      try {
        this.form.html = prettier.format(this.form.html || "", {
          parser: "html",
          plugins: [parserHtml],
          tabWidth: 2,
          useTabs: false
        });
      } catch (err) {
        alert("Invalid HTML syntax");
      }
    },

    loadAvailableFields() {
      user.getDocumentFields()
        .then(res => {
          this.availableFields = res.data.data || [];
        })
        .catch(() => {
          this.availableFields = [];
        });
    },

    addTemplateField(event) {
      if (!event.target.value) return;
      
      try {
        const field = JSON.parse(event.target.value);
        // Check if field already exists
        const exists = this.form.templateFields.some(f => f.id === field.id);
        if (!exists) {
          this.form.templateFields.push({
            ...field,
            order: this.form.templateFields.length + 1
          });
        }
      } catch (e) {
        console.error("Failed to parse field", e);
      }
      event.target.value = '';
    },

    removeTemplateField(index) {
      this.form.templateFields.splice(index, 1);
      // Recalculate order
      this.form.templateFields.forEach((field, idx) => {
        field.order = idx + 1;
      });
    },

    loadDocument() {
      user.getAllDocuments().then(res => {
        const docs = res.data.data || [];
        const doc = docs.find(d => d.id == this.documentId);
        if (doc) {
          this.documentName = doc.name;
          this.editName = doc.name;
        }
      });
    },

    openModal() {
      this.form = { id: null, name: "", template_type: "existing_details", html: "", templateFields: [] };
      this.loadAvailableFields();
      this.modal.show();
    },

    async editTemplate(template) {
      this.form = {
        id: template.id,
        name: template.name,
        template_type: template.template_type || "user",
        html: template.template_html || "",
        templateFields: []
      };
      this.loadAvailableFields();
      
      // Load linked fields for custom_details templates
      if (template.template_type === 'custom_details') {
        try {
          const res = await user.getTemplateFields(template.id);
          this.form.templateFields = res.data.data || [];
        } catch (err) {
          console.error("Error loading template fields:", err);
          this.form.templateFields = [];
        }
      }
      
      this.modal.show();
    },

    closeModal() {
      this.modal.hide();
    },

    loadTemplates() {
      user.getTemplates(this.documentId)
        .then(res => {
          this.templates = res.data.data || [];
        })
        .catch(() => {
          this.templates = [];
        });
    },
    save() {
      const payload = {
        document_id: this.documentId,
        name: this.form.name,
        template_html: this.form.html,
        template_type: this.form.template_type
      };

      if (!this.form.name || !this.form.name.trim()) {
        this.$swal("Warning", "Template name required", "warning");
        return;
      }

      if (this.form.id) {
        user.updateTemplate(this.form.id, payload)
          .then(async () => {
            // Link fields to template if custom_details type
            if (this.form.template_type === 'custom_details') {
              const fieldMappings = this.form.templateFields.map((field, idx) => ({
                field_id: field.id,
                is_mandatory: field.is_mandatory || false,
                order: idx + 1
              }));
              try {
                await user.linkTemplateFields(this.form.id, fieldMappings);
              } catch (err) {
                console.error("Error linking fields:", err);
              }
            }
            this.modal.hide();
            this.loadTemplates();
            this.$swal("Success", "Template updated successfully", "success");
          })
          .catch(() => {
            this.$swal("Error", "Failed to update template", "error");
          });
      } else {
        user.createTemplate(payload)
          .then(async (res) => {
            const templateId = res.data.data.id;
            // Link fields to template if custom_details type
            if (this.form.template_type === 'custom_details') {
              const fieldMappings = this.form.templateFields.map((field, idx) => ({
                field_id: field.id,
                is_mandatory: field.is_mandatory || false,
                order: idx + 1
              }));
              try {
                await user.linkTemplateFields(templateId, fieldMappings);
              } catch (err) {
                console.error("Error linking fields:", err);
              }
            }
            this.modal.hide();
            this.loadTemplates();
            this.$swal("Success", "Template added successfully", "success");
          })
          .catch(() => {
            this.$swal("Error", "Failed to add template", "error");
          });
      }
    },
    updateDocumentName() {
      if (!this.editName || !this.editName.trim()) {
        this.$swal("Warning", "Document name required", "warning");
        return;
      }

      user.updateDocument(this.documentId, { name: this.editName })
        .then(() => {

          this.documentName = this.editName;
          this.isEditingName = false;
          this.$swal({
            title: "Success",
            text: "Document name updated successfully",
            icon: "success",
            confirmButtonText: "OK"
          });

        })
        .catch(() => {
          this.$swal("Error", "Unable to update document", "error");
        });
    },

    removeTemplate(id) {
      this.$swal({
        title: "Delete",
        text: "Are you sure you want to delete?",
        type: "warning",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#32a852",
        cancelButtonColor: "#f00",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value || result.isConfirmed) {
          user
            .deleteTemplate(id)
            .then((res) => {
              const msg =
                res.data && res.data.message
                  ? res.data.message
                  : "Template deleted successfully";
              this.loadTemplates();
              this.$swal("Success", msg, "success");
            })
            .catch((err) => {
              let message = "Failed to delete template";
              if (err.response && err.response.data) {
                message =
                  err.response.data.detail ||
                  err.response.data.message ||
                  message;
              }
              this.$swal("Error", message, "error");
            });
        }
      });
    },



    startEditName() {
      this.editName = this.documentName;
      this.isEditingName = true;
    },

    cancelEditName() {
      this.isEditingName = false;
      this.editName = this.documentName;
    },
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal);
    this.$refs.modal.addEventListener("shown.bs.modal", () => {
      if (this.$refs.cm && this.$refs.cm.codemirror) {
        this.$refs.cm.codemirror.refresh();
      }
    });

    this.loadDocument();
    this.loadTemplates();
  },
};
</script>
